<template>
  <div>
    <h5>
      {{ i18n.t('/OrderInfoBlock/DealerInfo/BlockTitle') }}
      <button @click="showInfoModal = true">
        <icon icon="info-plain" large />
      </button>
    </h5>
    <address v-if="dealer">
      {{ dealer.DealerName }}<br />
      {{ dealer.DealerEmail }}<br />
      {{ dealer.DealerPhone }}<br />
      {{ dealer.DealerAddress }}<br />
      {{ dealer.DealerZipCode }}<br />
      {{ dealer.DealerCity }}
    </address>

    <modal
      v-if="showInfoModal"
      :title="i18n.t('/OrderInfoBlock/DealerInfo/InfoModalTitle')"
      @close="showInfoModal = false"
    >
      <p>
        {{ i18n.t('/OrderInfoBlock/DealerInfo/InfoModalText') }}
      </p>
    </modal>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      dealer: {},
      showInfoModal: false,
    }
  },
  mounted() {
    StoreConnector.get('quote/dealer', (data) => {
      this.dealer = data
    })
  },
}
</script>

<style></style>
